module.exports = __webpack_public_path__ + "img/head-banner.631ed57e.jpg";